import React from "react";

import "../scss/CustomerIndex.css"
import DataTableComponent from "./DataTableComponent";

export default class ComplianceDataTable extends React.Component {

    render() {
        return <DataTableComponent
            tableColumnConfig={[
                {
                    dataField: "type",
                    header: "Type"
                },
                {
                    header: "Compliant",
                    dataField: "compliant",
                    type: "boolean"
                }
            ]}
            tableData={this.props.tableData}
            search={false}
            pagination={false}
        />

    }
}
